module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "bordered-card"
  }, [_c('v-toolbar', {
    staticClass: "grey lighten-4 elevation-0"
  }, [_c('v-toolbar-title', {
    staticClass: "grey--text text-underline text--darken-4"
  }, [_vm._v("\n      Questionnaire Page\n    ")])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('block', {
    attrs: {
      "items": _vm.items,
      "submitData": _vm.submitData,
      "loading": _vm.loading,
      "type": "questionnaire",
      "data": _vm.settings
    }
  })], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 3000,
      "success": _vm.updateProcess,
      "error": _vm.status === 'error'
    },
    model: {
      value: (_vm.updateProcess),
      callback: function($$v) {
        _vm.updateProcess = $$v
      },
      expression: "updateProcess"
    }
  }, [_vm._v(_vm._s(_vm.process) + "\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6061ffa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/settings/Pages/questionnaire.vue
// module id = 1691
// module chunks = 2